module.exports = __webpack_public_path__ + "static/sign-up-298b2120a22f5314e359282951a18815.png";